// ─── ⏱️ Quanto dura: il pezzo che si tocca col dito ──────────────────────────
//
// 🗣️ 18/09/2026: *«sempre come maestro dalla mia sezione mi devi far modificare
//    la durata di una lezione o di un corso»*.
//
// ⚖️ **Un pezzo solo per tre schermate** — prenotare, la scheda di una lezione,
//    la scheda di un corso. Le tre fanno lo stesso gesto con lo stesso dito, e
//    tre copie dell'elenco delle durate divergerebbero il giorno in cui qualcuno
//    ne aggiunge una: la copia dimenticata sarebbe quella che si usa di rado.
//
// ⛔ **Niente tendina, e niente campo numerico.** Una tendina su un telefono
//    apre un rullo che copre la pagina, e un campo numerico chiede di battere
//    tre cifre a bordo campo per dire «un'ora e mezza». Qui si tocca la cosa che
//    si vuole: sono tre bersagli da 44 px.

import type React from 'react';

/**
 * ⚖️ Tre, e sono quelle vere: un'ora, un'ora e mezza, due ore. Non è un limite —
 * la durata che una prenotazione ha già compare comunque (⇒ `con`), quindi una
 * lezione messa dalla segreteria a 45′ si vede e si può ritoccare.
 */
export const DURATE = [60, 90, 120];

/** «1 ora e mezza», non «90». Chi legge sta pensando in ore, non in minuti. */
export function scriviDurata(d: number): string {
  return d === 60 ? '1 ora' : d === 90 ? '1 ora e mezza' : d === 120 ? '2 ore' : `${d} min`;
}

/**
 * Le durate da mostrare: le tre solite **più** quella che c'è già, se è diversa.
 * ⚠️ Senza questa unione, aprire una lezione da 45′ mostrerebbe tre bottoni
 * nessuno dei quali è quello acceso — cioè uno stato che sembra un difetto.
 */
export function con(durata: number | null): number[] {
  return [...new Set(durata === null ? DURATE : [...DURATE, durata])].sort((a, b) => a - b);
}

export function ScegliDurata({
  durata,
  scegli,
  disabilitato = false,
  etichetta = 'Quanto dura',
}: {
  /** Quella di adesso, o `null` quando le volte di un corso non durano uguale. */
  durata: number | null;
  scegli: (d: number) => void;
  disabilitato?: boolean;
  etichetta?: string;
}): React.JSX.Element {
  return (
    <div className="durate-maestro" role="group" aria-label={etichetta}>
      {con(durata).map((d) => (
        <button
          key={d}
          type="button"
          className={d === durata ? 'scelto' : ''}
          aria-pressed={d === durata}
          disabled={disabilitato}
          onClick={() => scegli(d)}
        >
          {scriviDurata(d)}
        </button>
      ))}
    </div>
  );
}
